// const IMG_DOMAIN_URL = "http://r22lp9bey.hb-bkt.clouddn.com";

const DELETE_STATUS_YES=0; // 删除状态
const DELETE_STATUS_NO=1; //正常没有删除
// 选择状态
const CHOISE_STATUS_YSE=1; //可用
const CHOISE_STATUS_NO=0; //禁用


const CASE_STATUS_QUOTATION="quotation" //报价中
const CASE_STATUS_BIDDING="bidding";//投标中
const CASE_STATUS_BIDDED="bidded";//已投标
const CASE_STATUS_OUTBID="outbid";//已投标
const CASE_STATUS_ENTRUST="entrust";//已委托
const CASE_STATUS_STORAGE="storage";//已入库
export default{

    DELETE_STATUS_YES,
    DELETE_STATUS_NO,
   // 是否状态
    CHOISE_STATUS_YSE,
    CHOISE_STATUS_NO,
    CASE_STATUS_QUOTATION, //报价中
    CASE_STATUS_BIDDING, //报价中
    
    CASE_STATUS_BIDDED,//已投标
    CASE_STATUS_OUTBID,//中标
    CASE_STATUS_ENTRUST,
    CASE_STATUS_STORAGE,
   

}